/**
 * Which published versions Deploy renders (PSTUDIO-4788). A solution can have
 * hundreds of publishes, and each row mounts several design-system components,
 * so only the newest `limit` are rendered — plus any `pinned` one further back,
 * such as the version an environment runs after a republish of an old one.
 *
 * Each row keeps its `index` in the full list: a row's diff compares with the
 * version published before it, not with the row rendered above it.
 *
 * `next` is how many rows raising the limit by `page` would add: a pinned row
 * inside that page is already on screen, so it doesn't count.
 */
export const pickVisibleVersions = <T extends { version: string | null }>(
  list: T[],
  {
    limit,
    page = limit,
    pinned,
  }: { limit: number; page?: number; pinned: (version: string) => boolean }
): { rows: { item: T; index: number }[]; hidden: number; next: number } => {
  const isPinned = (item: T) => !!item.version && pinned(item.version);
  const rows = list
    .map((item, index) => ({ item, index }))
    .filter(({ item, index }) => index < limit || isPinned(item));
  const next = list
    .slice(limit, limit + page)
    .filter((item) => !isPinned(item)).length;
  return { rows, hidden: list.length - rows.length, next };
};
